import HttpService from './http.service.js';

class DiagramService {
  getDiagram() {
    return HttpService.get('http://gsx2json.com/api?id=1pfuOwiRjMZAeRPKMztQVSlWUkPJMy7D9EXo_U7YB9Oo&sheet=1&columns=false')
    // return HttpService.get('https://spreadsheets.google.com/feeds/list/1pfuOwiRjMZAeRPKMztQVSlWUkPJMy7D9EXo_U7YB9Oo/1/public/full?alt=json')
      .then((res) => res.data.rows);
  }
}

export default new DiagramService();
